import { jsx as _jsx } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { Popover } from '@blueprintjs/core';
import { css } from '@emotion/react';
import { Formik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import FormikInput from '../elements/formik/FormikInput';
const InputDimension = { height: 28, width: 100 };
const validationSchema = (inputType) => Yup.object({
    value: (inputType === 'number' ? Yup.number() : Yup.string()).required(),
});
function stopPropagation(e) {
    e.stopPropagation();
}
function keyDownCheck(event) {
    if (event.key === 'Enter') {
        return true;
    }
    else if (event.key === 'Escape') {
        return false;
    }
}
export function FieldEdition(props) {
    const { value, inputType = 'text', onChange, children, PopoverProps } = props;
    const [isOpen, setIsOpen] = useState(false);
    function handleOnSubmit({ value: newValue }) {
        onChange(newValue);
        setIsOpen(false);
    }
    return (_jsx(Popover, { css: css `
        .field-edition-popover {
          border-radius: 5px;
        }
      `, popoverClassName: "field-edition-popover", isOpen: isOpen, onClose: () => setIsOpen(false), onInteraction: () => setIsOpen(true), content: _jsx(Formik, { initialValues: { value }, onSubmit: handleOnSubmit, validationSchema: validationSchema(inputType), children: ({ submitForm }) => (_jsx(FormikInput, { type: inputType, style: {
                    input: {
                        height: `${InputDimension.height}px`,
                        padding: '5px',
                        outline: 'none',
                    },
                }, name: "value", autoSelect: true, onKeyDown: (e) => keyDownCheck(e) && submitForm(), onClick: stopPropagation, onMouseDown: stopPropagation })) }), ...PopoverProps, children: children }));
}
